// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c126cfb0","213":"82e574c4","455":"c0fbe64d"}[chunkId] + ".chunk.js";
};